import type React from 'react';

import { useGetFace } from '@vlabs/api/luna-api/client';
import type { FaceId } from '@vlabs/api/luna-api/model';
import { PageHeader } from '@vlabs/monokit/shared/ui/page';
import { Breadcrumb, Breadcrumbs } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

import { routes } from '@vlapps/point/src/app/routes';

interface FacePageHeaderProps {
  faceId: FaceId;
}

function FacePageHeader({
  faceId,
}: FacePageHeaderProps): React.JSX.Element {
  const { t } = useTranslation();
  const getFace = useGetFace(faceId);

  return (
    <PageHeader
      breadcrumbs={(
        <Breadcrumbs>
          <Breadcrumb
            caption={t('face-page:header.breadcrumbs.cards_and_lists')}
            href={generatePath(routes.cardsAndLists.activeTab, { activeTab: 'cards' })}
          />
          <Breadcrumb
            caption={t('face-page:header.breadcrumbs.card')}
            href={getFace.data?.external_id
              ? generatePath(routes.externalId.read, { externalId: getFace.data?.external_id })
              : undefined}
          />
          <Breadcrumb caption={t('face-page:header.breadcrumbs.face')} />
        </Breadcrumbs>
      )}
      title={t('face-page:header.title')}
    />
  );
}

export { FacePageHeader };
